import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//component
import AppHoc from "../../../../generics/AppHOC";

//useI18n
import useI18n from "../../../../i18n/useI18n"
//style
import css from "../../insightsAppMagneticStyle.less";

//utils
import {
  isDeviceInfoPage,
  getLocalStorageFlag,
  removeLocalStorageFlag
} from "../../../../utils/common";
import { routeURLs } from "../../../../utils/enums";

const mapStateToProps = state => {
  return {
    predictiveNetworks: state.vanalytics.predictiveNetworks
  };
};

const [HbrBreadcrumb, HbrBreadcrumbItem, HbrIcon] = reactWrapper([
  "hbr-breadcrumb",
  "hbr-breadcrumb-item",
  "hbr-icon"
]);

const getConfigs = (tViews) => ({
  deviceInfoConfig: {
    title: tViews('predictiveNetworks.deviceInfoPageTitle'),
    crumbs: [
      tViews('predictiveNetworks.predictiveNetworks'),
      tViews('predictiveNetworks.siteInfoPageTitle')
    ]
  },
  siteInfoCofig: {
    title: tViews('predictiveNetworks.siteInfoPageTitle'),
    crumbs: [
      tViews('predictiveNetworks.predictiveNetworks')
    ]
  }
});

const HeaderBar = () => {
  const { tViews } = useI18n('views')
  const navigate = useNavigate();
  const { deviceInfoConfig, siteInfoCofig } = getConfigs(tViews);
  const config = isDeviceInfoPage() ? deviceInfoConfig : siteInfoCofig;
  const appClassLabels = JSON.parse(getLocalStorageFlag("activeAppClasses"));

  return (
    <div className={css["header-bar-network-page"]}>
      <HbrBreadcrumb>
        {config.crumbs.map(crumb => {
          const isPredictiveNetworksCrumb = crumb.includes(
            tViews('predictiveNetworks.predictiveNetworks')
          );

          return (
            <HbrBreadcrumbItem
              onClick={() => {
                if (isPredictiveNetworksCrumb) {
                  navigate(routeURLs.pn);
                } else {
                  removeLocalStorageFlag("pathDetails");
                  navigate(routeURLs.appInfoAtSite);
                }
              }}
              key={crumb}
            >
              <div className="predictive-breadcrumb-item">
                {isPredictiveNetworksCrumb && (
                  <HbrIcon
                    name="arrow-left"
                    label={tViews('a11yLabels.backNavigation')}
                  />
                )}
                {crumb}
              </div>
            </HbrBreadcrumbItem>
          );
        })}
      </HbrBreadcrumb>
      <div className="network-site-info hbr-type-h2" role="heading" aria-level={'1'}>
        {config.title}
        <span className="app-group-label hbr-type-body3">{appClassLabels[getLocalStorageFlag("appGroup")]}</span>
      </div>
    </div>
  );
};

export default (
  connect(mapStateToProps)(AppHoc(HeaderBar))
);
